import { createAction } from '@atc/modular-redux';

// Action Creators
import hydrateUserInventoryActionCreator from './hydrateUserInventoryActionCreator';
import saveSearchItemActionCreator from './saveSearchItemActionCreator';
import unsaveSearchItemActionCreator from './unsaveSearchItemActionCreator';
import updateSavedSearchItemActionCreator from './updateSavedSearchItemActionCreator';
import showQuickSaveListActionCreator from './showQuickSaveListActionCreator';
import cancelAlertsActionCreator from './cancelAlertsActionCreator';
import cancelSearchAlertsActionCreator from './cancelSearchAlertsActionCreator';
import updateAlertsActionCreator from './updateAlertsActionCreator';
import updateSearchAlertsActionCreator from './updateSearchAlertsActionCreator';
import registerLightUserActionCreator from './registerLightUserActionCreator';
import registerBestDealsActionCreator from './registerBestDealsActionCreator';
import saveRecentInventoryActionCreator from './saveRecentInventoryActionCreator';
import hydrateRecentInventoryActionCreator from './hydrateRecentInventoryActionCreator';
import setLeadProfileActionCreator from './setLeadProfileActionCreator';
import setCachedTextAlertsActionCreator from './setCachedTextAlertsActionCreator';
import setUserProfileActionCreator from './setUserProfileActionCreator';
import hydratePsxNotificationsActionCreator from './hydratePsxNotificationsActionCreator';
import hydrateMyCarsActionCreator from './hydrateMyCarsActionCreator';
export default (duck, personalization, inventoryDuck, savedInventoryDuck) => ({
  convertLocalSaves: () => async () => {},
  showUserState: createAction(duck.types.SHOW_USER_STATE),
  showUpdateSavedSearch: createAction(duck.types.SHOW_UPDATE_SAVED_SEARCH),
  hideUpdateSavedSearch: createAction(duck.types.HIDE_UPDATE_SAVED_SEARCH),
  setUpdateSavedSearchState: createAction(duck.types.SET_UPDATE_SAVED_SEARCH_STATE),
  showQuickSaveList: showQuickSaveListActionCreator(duck, personalization, inventoryDuck, savedInventoryDuck),
  hideQuickSaveList: createAction(duck.types.HIDE_QUICK_SAVE_LIST),
  clearGlobalAlert: createAction(duck.types.CLEAR_GLOBAL_ALERT),
  clearUI: createAction(duck.types.CLEAR_UI),
  clearLocation: createAction(duck.types.CLEAR_LOCATION),
  // setters
  setGlobalAlert: createAction(duck.types.SET_GLOBAL_ALERT),
  setRecentInventory: createAction(duck.types.SET_RECENT_INVENTORY),
  setLocation: createAction(duck.types.SET_LOCATION),
  setUserProfile: setUserProfileActionCreator(duck, personalization),
  setLeadProfile: setLeadProfileActionCreator(duck, personalization),
  setSavedSearchIds: createAction(duck.types.SET_SAVED_SEARCH_IDS),
  hydrateUserInventory: hydrateUserInventoryActionCreator(duck, savedInventoryDuck, personalization),
  hydrateRecentInventory: hydrateRecentInventoryActionCreator(duck, personalization),
  clearProfile: () => async dispatch => {
    personalization.logOut();
    dispatch({
      type: duck.types.CLEAR_PROFILE
    });
  },
  // User Inventory
  saveRecentInventory: saveRecentInventoryActionCreator(duck, personalization),
  editRecentSearch: data => async dispatch => {
    // attempt to edit inventory search. If no index is provided, the latest search will be altered.
    const {
      items
    } = await personalization.editInventorySearch(data);
    dispatch(duck.creators.setRecentSearches(items));
  },
  updateSavedInventory: createAction(duck.types.UPDATE_SAVED_INVENTORY),
  // User Search
  saveSearchItem: saveSearchItemActionCreator(duck, personalization),
  unsaveSearchItem: unsaveSearchItemActionCreator(duck, personalization),
  updateSavedSearchItem: updateSavedSearchItemActionCreator(duck, personalization, savedInventoryDuck),
  setSavedSearchItem: createAction(duck.types.SET_SAVED_SEARCH_ITEM),
  setSearchBookmarks: createAction(duck.types.SET_SEARCH_BOOKMARKS),
  setInventoryBookmarks: createAction(duck.types.SET_INVENTORY_BOOKMARKS),
  // Recommended Inventory
  setRecommendedInventory: createAction(duck.types.SET_RECOMMENDED_INVENTORY),
  // Email Subscribe
  setSubscribeSearchItem: createAction(duck.types.SET_SUBSCRIBE_SEARCH_ITEM),
  showEmailSubscribeInline: createAction(duck.types.SHOW_EMAIL_SUBSCRIBE_INLINE),
  hideEmailSubscribeModal: createAction(duck.types.HIDE_EMAIL_SUBSCRIBE_MODAL),
  showLightRegistrationServerError: createAction(duck.types.SHOW_LIGHT_REGISTRATION_SERVER_ERROR),
  registerEmailSubscribeUser: registerLightUserActionCreator(duck, personalization, savedInventoryDuck),
  // Best Deals
  showBestDealsRegistrationServerError: createAction(duck.types.SHOW_BEST_DEALS_REGISTRATION_SERVER_ERROR),
  registerBestDeals: registerBestDealsActionCreator(duck, personalization),
  showBestDeals: createAction(duck.types.SHOW_BEST_DEALS),
  showBestDealsSubscribeSuccess: createAction(duck.types.SHOW_BEST_DEALS_SUBSCRIBE_SUCCESS),
  // Cancel Alerts
  cancelAlerts: cancelAlertsActionCreator(duck, personalization),
  setCachedTextAlerts: setCachedTextAlertsActionCreator(duck, personalization),
  cancelSearchAlerts: cancelSearchAlertsActionCreator(duck, personalization),
  setAlertsModal: createAction(duck.types.SET_ALERTS_MODAL),
  // Cancel Account
  setCancelAccountConfirmation: createAction(duck.types.SET_CANCEL_ACCOUNT_CONFIRMATION),
  setCancelAccountModal: createAction(duck.types.SET_CANCEL_ACCOUNT_MODAL),
  showCancelAccountSuccess: createAction(duck.types.SHOW_CANCEL_ACCOUNT_SUCCESS),
  // Email Alerts
  updateAlerts: updateAlertsActionCreator(duck, personalization, savedInventoryDuck),
  updateSearchAlerts: updateSearchAlertsActionCreator(duck, personalization),
  addEmailAlertsItem: createAction(duck.types.ADD_EMAIL_ALERTS_ITEM),
  removeEmailAlertsItem: createAction(duck.types.REMOVE_EMAIL_ALERTS_ITEM),
  setEmailAlertsItems: createAction(duck.types.SET_EMAIL_ALERTS_ITEMS),
  setAlertsError: createAction(duck.types.SET_ALERTS_ERROR),
  // New User Welcome
  showNewUserModal: createAction(duck.types.SHOW_NEW_USER_MODAL),
  hydratePsxNotifications: hydratePsxNotificationsActionCreator(duck, personalization),
  hydrateMyCars: hydrateMyCarsActionCreator(duck, personalization),
  updateHasChatPreviouslyVdpListings: createAction(duck.types.UPDATE_HAS_CHAT_PREVIOUSLY_VDP_LISTINGS),
  setUserEditProfile: createAction(duck.types.SET_USER_EDIT_PROFILE)
});